export default __webpack_public_path__ + "static/media/financial-services.3739e63d.png";